import React, { useState, useEffect } from "react";

const BoardAdmin = () => {

  const currentMainThemeColor = localStorage.getItem("currentMainThemeColor") ?? "#135c13";
  const currentSecondaryThemeColor = localStorage.getItem("currentSecondaryThemeColor") ?? "#cfcfcf";

  const styles = {
    pageTitle: {
      padding: '2rem 1rem',
      marginBottom: '2rem',
      backgroundColor: currentSecondaryThemeColor, 
      borderRadius: '0.3rem',
      height: 200,
      display: 'flex',
      justifyContent: 'center',
    },
  }


  return (
    <div className="container">
      <header style={styles.pageTitle}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <h1>{'Admin board'}</h1>
        </div>
      </header>
      <div>
        <p style={{fontFamily: 'Comic Sans MS', fontSize: 22}}>
          This section is underconstruction... come back soon...
        </p>
      </div>
    </div>
  );
};

export default BoardAdmin;
